import { uniqueArray } from '@acceligentllc/shared/utils/array';

import type { EmployeeAssignment, TemporaryEmployeeAssignment } from './types';

interface GroupWorkOrderEmployeeAssignmentsEvent {
	workOrderEmployeeSmsIds: number[];
	workOrderEmployeeEmailIds: number[];
	workOrderEmployeeToAssignmentLookup: { [workOrderEmployeeId: string]: EmployeeAssignment; };
}

export const groupWorkOrderEmployeeAssignments = (event: GroupWorkOrderEmployeeAssignmentsEvent) => {

	const { workOrderEmployeeEmailIds, workOrderEmployeeSmsIds, workOrderEmployeeToAssignmentLookup } = event;

	const workOrderEmployeesLookup = [...workOrderEmployeeEmailIds, ...workOrderEmployeeSmsIds].reduce<{ [workOrderId: number]: number[]; }>((_acc, _woeId) => {
		const assignment = workOrderEmployeeToAssignmentLookup[_woeId];
		if (!assignment) {
			throw new Error('Could not find work order employee');
		}
		if (!_acc[assignment.workOrderId]) {
			_acc[assignment.workOrderId] = [];
		}
		_acc[assignment.workOrderId].push(assignment.employeeId);
		return _acc;
	}, {});

	return Object.entries(workOrderEmployeesLookup).map(([_woId, _employeeIds]) => {
		return { workOrderId: +_woId, employeeIds: uniqueArray(_employeeIds) };
	});
};

interface GroupWorkOrderTemporaryEmployeeAssignmentsEvent {
	workOrderTemporaryEmployeeEmailIds: number[];
	workOrderTemporaryEmployeeSmsIds: number[];
	workOrderTemporaryEmployeeToAssignmentLookup: { [workOrderEmployeeId: string]: TemporaryEmployeeAssignment; };
}

export const groupWorkOrderTemporaryEmployeeAssignments = (event: GroupWorkOrderTemporaryEmployeeAssignmentsEvent) => {

	const { workOrderTemporaryEmployeeEmailIds, workOrderTemporaryEmployeeSmsIds, workOrderTemporaryEmployeeToAssignmentLookup } = event;

	const workOrderTemporaryEmployeesLookup =
		[...workOrderTemporaryEmployeeEmailIds, ...workOrderTemporaryEmployeeSmsIds].reduce<{ [workOrderId: number]: number[]; }>((_acc, _woteId) => {
			const assignment = workOrderTemporaryEmployeeToAssignmentLookup[_woteId];
			if (!assignment) {
				throw new Error('Could not find work order temporary employee');
			}
			if (!_acc[assignment.workOrderId]) {
				_acc[assignment.workOrderId] = [];
			}
			_acc[assignment.workOrderId].push(assignment.temporaryEmployeeId);
			return _acc;
		}, {});

	return Object.entries(workOrderTemporaryEmployeesLookup).map(([_woId, _temporaryEmployeeIds]) => {
		return { workOrderId: +_woId, temporaryEmployeeIds: uniqueArray(_temporaryEmployeeIds) };
	});
};
